/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React from 'react';
import { Skeleton } from 'react-skeleton-generator';

function ViewOffersSkeleton() {
    return (
        <Skeleton.SkeletonThemeProvider highlight="light">
            <div className="">
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <a href="admin-manage-deal-list.html">
                            <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                        </a>
                        <h5 className="text-xs4 font-normal text-[#555259]">View Offer</h5>
                    </div>
                    <div>
                        <a href="edit-offer-deal.html">
                            <button type="button" className="w-[102px] border border-[#555259] rounded-lg h-[38px] text-xs6 font-bold text-[#555259]">
                                <Skeleton />
                            </button>
                        </a>
                        <button type="button" className="w-[147px] border border-[#555259] rounded-lg h-[38px] text-xs6 font-bold text-[#555259] ml-1" data-bs-toggle="modal" data-bs-target="#deactivateOfferModal1">
                            <Skeleton />
                        </button>
                    </div>
                </div>
                <div className="px-4 pt-[34px]">
                    <div className="flex -mx-2">
                        <div className="px-2 w-[14.28%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                            <p className="text-lg font-normal text-[#090406] pt-1.5"><Skeleton width="90px" height="25px" /></p>
                        </div>
                        <div className="px-2 w-[14.28%]">
                            <p className="text-xs2 font-semibold text-[#808285]">
                                <Skeleton height="15px" width="100px" />

                            </p>
                            <p className="text-lg font-normal text-[#090406] pt-1.5"><Skeleton width="90px" height="25px" /></p>
                        </div>
                        <div className="px-2 w-[14.28%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                            <p className="text-lg font-normal text-[#090406] pt-1.5"><Skeleton width="90px" height="25px" /></p>
                        </div>
                        <div className="px-2 w-[14.28%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                            <p className="text-lg font-normal text-[#090406] pt-1.5"><Skeleton width="90px" height="25px" /></p>
                        </div>
                        <div className="px-2 w-[14.28%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                            <p className="text-lg font-normal text-[#090406] pt-1.5"><Skeleton width="90px" height="25px" /></p>
                        </div>
                        <div className="px-2 w-[14.28%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                            <p className="text-lg font-normal text-[#090406] pt-1.5"><Skeleton width="90px" height="25px" /></p>
                        </div>
                        <div className="px-2 w-[14.28%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                            <p className="text-lg font-normal text-[#090406] pt-1.5"><Skeleton width="90px" height="25px" /></p>
                        </div>
                    </div>
                    <div className="pt-5 w-[90%]">
                        <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                        <p className="text-lg font-normal text-[#090406] pt-1"><Skeleton height="18px" width="500px" /></p>
                    </div>
                    {[...Array(2)].map((val) => (
                        <div className="mt-8 w-full" key={val}>
                            <h5 className="text-sm font-bold text-[#090406]"><Skeleton height="15px" width="150px" /></h5>
                            <div className="mt-2 rounded-[22px] bg-[#F5F5FA] px-2.5 pt-8 w-full">
                                <div>
                                    <p className="text-sm font-bold text-[#090406] pb-1.5 px-[22px]" />
                                    <div className="bg-[#ffffff] rounded-[16px] px-[22px] pt-4 pb-4">
                                        <div className="px-3.5">
                                            <div className="flex -mx-2 w-[90%]">
                                                <div className="px-2 w-1/4">
                                                    <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5"><Skeleton width="90px" height="25px" /></p>
                                                </div>
                                                <div className="px-2 w-1/4">
                                                    <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5"><Skeleton width="90px" height="25px" /></p>
                                                </div>
                                                <div className="px-2 w-1/4">
                                                    <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="100px" /></p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5"><Skeleton width="90px" height="25px" /></p>
                                                </div>
                                            </div>
                                            <div className="flex -mx-2 pb-2.5">
                                                <div className="px-2 mt-[22px]">
                                                    <p className="text-xs2 font-semibold text-[#808285]">Product 1</p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5">
                                                        <Skeleton width="250px" />
                                                        {' '}
                                                        {/* <span className="text-xs13"><Skeleton /></span> */}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="rounded-lg bg-[#F5F5FA] px-3.5 py-3 w-[90%]">
                                            <div className="flex -mx-2 pt-6">
                                                <div className="px-2 w-1/4">
                                                    <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="130px" /></p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5"><Skeleton width="90px" height="25px" /></p>
                                                </div>
                                                <div className="px-2 w-1/4">
                                                    <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="130px" /></p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5"><Skeleton width="90px" height="25px" /></p>
                                                </div>
                                                <div className="px-2 w-1/4">
                                                    <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="130px" /></p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5"><Skeleton width="90px" height="25px" /></p>
                                                </div>
                                                <div className="px-2 w-1/4">
                                                    <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="130px" /></p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5"><Skeleton width="90px" height="25px" /></p>
                                                </div>

                                            </div>
                                            <div className="flex -mx-2 pt-6">
                                                <div className="px-2 w-1/4">
                                                    <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="130px" /></p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5"><Skeleton width="90px" height="25px" /></p>
                                                </div>
                                                <div className="px-2 w-1/4">
                                                    <p className="text-xs2 font-semibold text-[#808285]"><Skeleton height="15px" width="130px" /></p>
                                                    <p className="text-lg font-normal text-[#090406] pt-0.5"><Skeleton width="90px" height="25px" /></p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="mt-[22px] w-[392px]">
                        <h5 className="text-sm font-bold text-[#090406]"><Skeleton width="200px" height="25px" /></h5>
                        <div className="mt-2 rounded-[22px] bg-[#F5F5FA] p-[15px] w-full">
                            {[...Array(3)].map((itemval) => (
                                <div>
                                    <p className="pt-1 text-xs6 font-normal text-[#090406]" key={itemval}>
                                        <span className="font-semibold">
                                            <Skeleton />
                                            {' '}

                                        </span>
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Skeleton.SkeletonThemeProvider>

    );
}

export default ViewOffersSkeleton;
